



































































































import { Component, Vue } from 'vue-property-decorator'
import { getOperationID } from '@/api/operations'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getBoUrl } from '@/api/http-constants'

@Component({})
export default class Plan extends Vue {
    apiService = new ApiService()
    boUrl: string = null

    userOpe: any = null
    plan: string = null
    remainingComments: string = null
    canComment: boolean = false

    comment: string = null
    file: File = null

    async created() {
        const opeId = await getOperationID()

        this.boUrl = getBoUrl()
        this.boUrl = this.boUrl.substring(0, this.boUrl.length - 1)

        if (UserModule.token == undefined) {
            UserModule.Init()
        }

        const userOpeResp = await this.apiService.getUserOperation(
            UserModule.userInfos.id,
            opeId
        )

        this.userOpe = userOpeResp.data

        this.canComment = this.userOpe.phase >= 4

        this.remainingComments = (
            3 -
            this.userOpe.blueprints.filter(plan => !plan.isUploadedByAdmin)
                .length
        )
            .toString()
            .padStart(2, '0')

        const adminBlueprints = this.userOpe.blueprints
            .filter(plan => plan.isUploadedByAdmin)

        this.plan = adminBlueprints.length > 0
            ? adminBlueprints.reduce((prev, curnt) => {
                return prev.createdAt < curnt.createdAt ? curnt : prev
            })
            : null
    }

    submit() {
        const req: {
            comment: string
            fileName?: string
            fileBase64?: string
        } = {
            comment: this.comment,
        }

        if (this.file) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(this.file)
            fileReader.onload = event => {
                req.fileName = this.file.name
                req.fileBase64 = fileReader.result as string
                this.apiService
                    .postOpeBluePrint(this.userOpe.operation.id, req)
                    .then(() => {
                        this.$emit(
                            'alert',
                            'success',
                            'Votre commentaire a bien été envoyé'
                        )
                        this.remainingComments = (
                            parseInt(this.remainingComments) - 1
                        )
                            .toString()
                            .padStart(2, '0')
                    })
                    .catch(error => {
                        this.$emit(
                            'alert',
                            'danger',
                            error.data.message
                                ? error.data.message
                                : "Une erreur est survenue lors de l'envoi du commentaire"
                        )
                    })
            }
        } else {
            this.apiService
                .postOpeBluePrint(this.userOpe.operation.id, req)
                .then(() => {
                    this.$emit(
                        'alert',
                        'success',
                        'Votre commentaire a bien été envoyé'
                    )
                    this.remainingComments = (
                        parseInt(this.remainingComments) - 1
                    )
                        .toString()
                        .padStart(2, '0')
                })
                .catch(error => {
                    console.log('error', error)
                    this.$emit(
                        'alert',
                        'danger',
                        error.data.message
                            ? error.data.message
                            : "Une erreur est survenue lors de l'envoi du commentaire"
                    )
                })
        }
    }
}
